import { render, staticRenderFns } from "./PricesArticleField.vue?vue&type=template&id=2f52f642"
import script from "./PricesArticleField.vue?vue&type=script&lang=js"
export * from "./PricesArticleField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports